import { toast } from 'react-toastify'
import i18n from '../i18n'

/**
 * Функция копирует значение в буфер обмена
 *
 * @param value - любая строка
 * @param successTranslate - параметр перевода успешного сообщения
 */
export const copyToClipboard = (value, successTranslate = null) => {
    const defaultSuccess = i18n.t('common.copy.success')
    navigator.clipboard
        .writeText(value)
        .then(() => {
            toast(successTranslate || defaultSuccess, {
                type: 'success',
            })
        })
        .catch(() => {
            toast(i18n.t('common.copy.error'), {
                type: 'error',
            })
        })
}
